<template>
  <global-dialog-card
    v-model="model"
    hide-actions
    :max-width="500"
    :title="$t('qr_code')"
  >
    <template #title-actions>
      <print-button
        class="mr-2"
        @click="printQr"
        color="white"
        :disabled="loading"
      ></print-button>
    </template>
    <div class="pt-7" v-if="employee">
      <v-row justify="center">
        <v-col cols="12" v-if="loading" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
          <div class="mt-3">{{ $t("generating_qr_code") }}</div>
        </v-col>
        <template v-else-if="selectedQrSecret">
          <v-col cols="5">
            <qrcode-vue
              id="qrkodstampa"
              :value="
                JSON.stringify({
                  id: employee.id,
                  secure: selectedQrSecret,
                })
              "
              :size="160"
              level="H"
              render-as="svg"
            />
          </v-col>
          <v-col cols="7">
            <div
              style="color: #000 !important; font-weight: 900; margin-left: -15px"
              class="p-3"
            >
              <div>Ordera ID: {{ employee.id }}</div>
              <div>
                {{ toLatin(employee.name) + " " + toLatin(employee.lastname) }}
              </div>
              <div>{{ employee.email }}</div>
              <div v-if="employee.external_code">
                {{ $t("access_card_id") }}: {{ employee.external_code }}
              </div>
            </div>
          </v-col>
        </template>
        <v-col cols="12" v-else class="text-center">
          <v-icon size="64" color="grey lighten-1">mdi-qrcode-remove</v-icon>
          <div class="mt-3 grey--text">{{ $t("error_generating_qr") }}</div>
        </v-col>
      </v-row>
    </div>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasPrinting from "@/mixins/hasPrinting";
import hasSnackbar from "@/mixins/hasSnackbar";
import QrcodeVue from "qrcode.vue";
import userService from "@/services/user";

export default {
  name: "CompanyEmployeeDialogQr",
  mixins: [hasModel, hasPrinting, hasSnackbar],
  components: {
    QrcodeVue,
  },
  props: {
    employee: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedQrSecret: null,
    qrIndex: null,
    loading: false,
  }),
  methods: {
    getEmployeeQr() {
      if (!this.employee) return;

      this.loading = true;
      this.selectedQrSecret = null; // Reset QR secret

      userService
        .getUserHash(this.employee.id)
        .then((res) => {
          this.selectedQrSecret = res.data;
        })
        .catch((error) => {
          console.error("Error getting QR hash:", error);
          this.showErrorSnackbar(this.$t("error_generating_qr_code"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEmployeeQrText(qrSvgHtml) {
      return `
        <div style="
          width: 420px;
          min-height: 160px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          display: flex;
          padding: 24px 32px;
          margin: 60px auto 0 auto;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        ">
          <div style="flex: 0 0 120px; display: flex; align-items: center; justify-content: center;">
            ${qrSvgHtml}
          </div>
          <div style="flex: 1; margin-left: 12px; display: flex; flex-direction: column; justify-content: start;position: relative;">
            <div style="font-size: 16px; font-weight: 600; margin-bottom: 2px;">
              ${this.toLatin(this.employee.name)} ${this.toLatin(this.employee.lastname)}
            </div>
            <div style="font-size: 13px; color: #555; margin-bottom: 2px;">${
              this.employee.email || ""
            }</div>
            <div style="font-size: 13px; color: #555; margin-bottom: ${
              this.employee.external_code ? "2px" : "12px"
            };">
              <strong>Ordera ID:</strong> ${this.employee.id}
              </div>
            <div style="font-size: 13px; color: #555; margin-bottom: 12px;display: ${
              this.employee.external_code ? "block" : "none"
            };">
              <strong>${this.$t("access_card_id")}:</strong> ${
        this.employee.external_code || ""
      }
            </div>
            <div style="display: flex; align-items: center; justify-content: end; position: absolute; bottom: 8px; right: 8px;">
              <span style="font-size: 13px; color: #888;">ordera.app</span>
              <img src="https://restorani.bitlab.host/img/o.png" alt="ordera.app" style="width: 24px; height: 24px; margin-left: 8px;">
            </div>
          </div>
        </div>
      `;
    },
    printQr() {
      // Don't allow printing while loading
      if (this.loading || !this.selectedQrSecret) return;

      // Get QR SVG as HTML
      const qrCodeElem = document.getElementById("qrkodstampa");
      let qrSvgHtml = "";
      if (qrCodeElem) {
        // For qrcode-vue, the SVG is the first child
        const svg = qrCodeElem.querySelector("svg");
        if (svg) {
          qrSvgHtml = svg.outerHTML;
        } else {
          // fallback: maybe the element itself is svg
          if (qrCodeElem.tagName.toLowerCase() === "svg") {
            qrSvgHtml = qrCodeElem.outerHTML;
          }
        }
      }
      this.printDocument({
        beforeTableHtml: this.getEmployeeQrText(qrSvgHtml),
        hideDatetime: true,
        additionalStyles: `
          @media print {
            body {
              background: #f5f5f5;
            }
          }
        `,
      });
    },
  },
  watch: {
    model(val) {
      if (val) {
        this.getEmployeeQr();
      }
    },
  },
};
</script>
